import React, { useEffect, useState } from 'react';
import {
  DataTable,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TableBatchActions,
  TableBatchAction,
  TableToolbar,
  TableSelectAll,
  TableSelectRow,
} from '@carbon/react';
import { TrashCan } from '@carbon/icons-react';
import SectionLoader from '../Loader/SectionLoader';
import PaginationComponent from '../Pagination';

export default function DataTableControl(props) {
  const { columns, title, batchActionClick, isSort, loading, getData } = props;
  const [docs, setDocs] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    hasNextPage: false,
    hasPrevPage: false,
    nextPage: 1,
    pagingCounter: 0,
    prevPage: false,
    totalDocs: 0,
    totalPages: 0,
  });

  const { limit, page, totalDocs } = pagination || {};

  useEffect(() => {
    async function fetchData() {
      const res = await getData(pagination);
      setDocs(res?.docs || []);
      setPagination(res);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePagination = async (e) => {
    const value = { ...pagination, page: e?.page, limit: e?.pageSize };
    setPagination(value);
    const res = await getData(value);
    setDocs(res?.docs || []);
  };

  return (
    <div>
      <DataTable
        rows={docs || []}
        headers={columns}
        // future if you need any modification then we can use below code.
        // headers={props.columns.map((data) => {
        //   //manage column props here that you want to make it available in Header component
        //   return {
        //     header: data.title,
        //     key: data.key,
        //     sortable: data.sort able
        //   }
        // })}
        isSortable={isSort ? true : false}
      >
        {({
          rows,
          headers,
          getHeaderProps,
          getTableProps,
          getBatchActionProps,
          getToolbarProps,
          selectedRows,
          getSelectionProps,
        }) => {
          const batchActionProps = getBatchActionProps();
          return (
            <TableContainer title={title}>
              {loading && <SectionLoader />}
              {batchActionProps &&
                batchActionProps?.shouldShowBatchActions === true && (
                  <TableToolbar {...getToolbarProps()}>
                    <TableBatchActions {...batchActionProps}>
                      <TableBatchAction
                        tabIndex={
                          batchActionProps.shouldShowBatchActions ? 0 : -1
                        }
                        renderIcon={TrashCan}
                        onClick={() => batchActionClick(selectedRows, 'delete')}
                      >
                        Delete
                      </TableBatchAction>
                    </TableBatchActions>
                  </TableToolbar>
                )}
              <Table {...getTableProps()}>
                <TableHead>
                  <TableRow>
                    <TableSelectAll {...getSelectionProps()} />
                    {headers.map((header) => (
                      <TableHeader
                        {...getHeaderProps({
                          header,
                          isSortable: header?.sortable === true,
                        })}
                      >
                        {header.header}
                      </TableHeader>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows &&
                    rows?.length > 0 &&
                    rows.map((row) => (
                      <TableRow key={row.id}>
                        <TableSelectRow {...getSelectionProps({ row })} />
                        {row &&
                          row?.cells &&
                          row?.cells?.length > 0 &&
                          row?.cells?.map((cell, index) => (
                            <TableCell key={cell.id}>
                              {!columns[index].render && cell.value}
                              {columns[index].render &&
                                columns[index].render(cell.value)}
                            </TableCell>
                          ))}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          );
        }}
      </DataTable>
      <PaginationComponent
        pageSize={limit}
        page={page}
        totalItems={totalDocs}
        handleChange={handleChangePagination}
      />
    </div>
  );
}
